import React from 'react';
import svg from '../assets/loading.svg';

export default function LoaderSubmit() {
    return <img width={40} src={svg} alt="Loading..." />;
}
